/* DHC v905 — homepage Ask Jack actions */
(function(){
'use strict';
function openAndPrompt(prompt){
  try{
    if(typeof window.DHCOpenJack==='function')window.DHCOpenJack();
    var widget=document.querySelector('[data-dhc-support]');
    if(!widget)return;
    var panel=widget.querySelector('[data-support-panel]');
    var form=widget.querySelector('[data-support-form]');
    var input=form&&form.elements&&form.elements.message;
    if(panel){
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden','false');
      panel.style.display='';
      panel.style.visibility='';
      panel.style.opacity='';
      panel.style.pointerEvents='';
    }
    if(!form||!input)return;
    var p=String(prompt||'').trim();
    if(!p){setTimeout(function(){try{input.focus()}catch(e){}},50);return;}
    input.value=p;
    form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
    setTimeout(function(){if(input.value===p)input.value='';},0);
  }catch(e){}
}
function bind(){
  document.querySelectorAll('[data-dhc-jack-home-prompt]').forEach(function(btn){
    if(btn.dataset.dhcV905Bound==='1')return;
    btn.dataset.dhcV905Bound='1';
    btn.addEventListener('click',function(e){
      e.preventDefault();
      openAndPrompt(btn.getAttribute('data-dhc-jack-home-prompt'));
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind,{once:true});
else bind();
document.addEventListener('shopify:section:load',bind);
})();